export enum Motivo
{
    Plazo,
    Impuestos,
    Otros,
    Precio,
    Despacho,
    Litros,
    Servicios
}
